
<div class="inner-adjust">
   <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Compétences</h1>
      <div class="row">
        <div class="col-12"><span class="font-weight-bold">IMPORTANT</span>: La description courte du menu déroulant est là à titre indicatif.</div>
        <div class="col-3"><span class="label">Crimsons disponible: </span>{{personnage?.crimsonDisponible}}</div>
        <div class="col-3"><span class="label">Case de compétences disponible: </span>{{personnage?.achatDisponible}}</div>
        <div class="col-3"><span class="label">Points d'achat disponible: </span>{{personnage?.achatSortDisponible}}</div>
        <form [formGroup]="addCompetenceForm" (ngSubmit)="onSubmit()">
            <div class="col-9 form-group pt-2">
              <ng-select [items]="availableCompetences" bindLabel="nom" bindValue="id" formControlName="addedCompetenceId">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="select-title">
                    {{item.nom}} - Niveau 1{{item.niveau2 != null? "/2":""}}{{item.niveau3 != null? "/3":""}} - 
                    {{item.niveau1.cout}}{{item.niveau2 != null? "/"+item.niveau2.cout:""}}{{item.niveau3 != null? "/"+item.niveau3.cout:""}} Crimsons
                  </div>
                  <div class="description">{{item.descriptionCourte}}</div>
                  <div class="avertissement">{{item.avertissement}}</div>
                </ng-template>
              </ng-select>
              <div *ngIf="submitted && f['addedCompetenceId'].errors" class="invalid-feedback">
                  <div *ngIf="f['addedCompetenceId'].errors['required']">Compétence requise</div>
              </div>
            </div>
            <div class="col pt-3">
                <input type="submit" value="Ajouter compétence" class="btn btnPrimary" >
            </div>
        </form>
      </div>
      <div class="row pb-2" *ngFor="let competencePersonnage of personnage?.competences">
        <div class="col-9">
          <h2>{{GetCompetence(competencePersonnage.competenceId)?.nom}} - niveau {{competencePersonnage.niveau}}</h2>
          <div class="description">{{GetCompetence(competencePersonnage.competenceId)?.description}}</div>
          <div class="label">{{GetCompetence(competencePersonnage.competenceId)?.niveau1?.description}}</div>
          <div class="label" *ngIf="competencePersonnage.niveau >= 2">{{GetCompetence(competencePersonnage.competenceId)?.niveau2?.description}}</div>
          <div class="label" *ngIf="competencePersonnage.niveau >= 3">{{GetCompetence(competencePersonnage.competenceId)?.niveau3?.description}}</div>
          <div class="avertissement">{{GetCompetence(competencePersonnage.competenceId)?.avertissement}}</div>
        </div>
        <div class="col">
          <button ngbTooltip="Ajouter un niveau" [disabled]="!canAddNiveauCompetence(competencePersonnage)" (click)="AddNiveauCompetence(competencePersonnage)">+</button>
          <button ngbTooltip="Retirer un niveau" [disabled]="!canRemoveNiveauCompetence(competencePersonnage)" (click)="RemoveNiveauCompetence(competencePersonnage)">-</button>
          <button ngbTooltip="Retirer la compétence" [disabled]="!canRemoveCompetence(competencePersonnage)" (click)="RemoveCompetence(competencePersonnage)">Retirer</button>
        </div>
        <hr />
      </div>
  </div>